import { SET_SEARCH_TEXT, SET_ONLY_PADRAO } from './mutations.type';

export default {
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_ONLY_PADRAO](state, onlyPadrao) {
    state.onlyPadrao = onlyPadrao;
  },
};
